<div class="widget-dashboard">
  <div class="widget-dashboard__header">
    <p-buttongroup class="dashboard-menu">
      <p-button
        [label]="displaySwitchButtonLabel"
        class="dashboard-menu__item--left"
        [rounded]="true"
        [icon]="isEditing ? 'pi pi-save' : 'pi pi-pencil'"
        severity="secondary"
        size="small"
        (click)="toggleEditable()" />
      <p-button
        label="Add widget"
        i18n-label="@@widget_dashboard.actions.add_widget"
        class="dashboard-menu__item--right"
        [rounded]="true"
        size="small"
        [disabled]="isEditing || !canAddWidget"
        (click)="showWidgetCreationDialog()" />
    </p-buttongroup>
  </div>
  <div
    class="widget-dashboard__content"
    [ngClass]="{ 'widget-dashboard__content--editing': isEditing }">
    <gridster [options]="options">
      @for (widget of (widgets$ | async)!; track widget) {
        <gridster-item [item]="widget.positionConfiguration">
          <carehub-widget-card
            [widget]="widget"
            (widgetDelete)="deleteWidget($event)"
            [isEditing]="isEditing"
            (widgetChange)="updateWidget($event)"></carehub-widget-card>
        </gridster-item>
      }
    </gridster>
  </div>
</div>

<carehub-widget-creation
  [(visible)]="isWidgetCreationDialogVisible"
  [canAddWidget]="canAddWidget"
  (widgetCreated)="onWidgetCreated($event)"
  (widgetTypeSelected)="onWidgetTypeSelected($event)">
</carehub-widget-creation>

<p-confirmdialog />
